var map = {
	"./TranslatedWordcount.svg": "827a",
	"./avatar.svg": "0f62",
	"./caogaoxiang.svg": "11aa",
	"./eyecloseline.svg": "b6c5",
	"./eyeline.svg": "a895",
	"./file.svg": "fe3c",
	"./fire.svg": "340c",
	"./home/c_corpora.svg": "09b5",
	"./home/c_corpora_small.svg": "9615",
	"./home/c_order.svg": "9126",
	"./home/c_order_small.svg": "a3c4",
	"./home/c_saving.svg": "dd5e",
	"./home/c_saving_small.svg": "1852",
	"./home/h_accept.svg": "8a8e",
	"./home/h_account.svg": "3c8f",
	"./home/h_active.svg": "e85f",
	"./home/h_order.svg": "99b6",
	"./home/h_quote.svg": "54a1",
	"./home/s_time.svg": "f137",
	"./home/s_time_small.svg": "6a06",
	"./menu/coConfig.svg": "3738",
	"./menu/coConfig_o.svg": "01d3",
	"./menu/customer.svg": "4fdc",
	"./menu/customerConfig.svg": "5d7f",
	"./menu/customerConfig_o.svg": "564f",
	"./menu/customer_o.svg": "7440",
	"./menu/employee.svg": "9f08",
	"./menu/employee_o.svg": "0254",
	"./menu/home.svg": "adc3",
	"./menu/home_o.svg": "c3f7",
	"./menu/payment.svg": "8bd5",
	"./menu/payment_o.svg": "2bbf",
	"./menu/personnel.svg": "2a82",
	"./menu/personnel_o.svg": "74fc",
	"./menu/project.svg": "4ba6",
	"./menu/project_o.svg": "c35a6",
	"./menu/report.svg": "66c9",
	"./menu/report_o.svg": "bc93",
	"./suiji.svg": "8350"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce50";